import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";

export const EditorialMarquee = () => (
    <div className="border-y border-border bg-sand py-6" data-testid="editorial-marquee">
        <Marquee speed={32} gradient={false} pauseOnHover>
            {MARQUEE_ITEMS.map((item) => (
                <span key={item} className="mx-6 flex items-center gap-6 font-serif text-2xl italic text-teal">
                    {item}
                    <span className="text-lg not-italic text-saffron">✳</span>
                </span>
            ))}
        </Marquee>
    </div>
);
